import { schema, normalize } from 'normalizr';
import {
  ADD_STUDENT,
  STUDENT_API_REQUEST,
  STUDENT_API_SUCCESS,
  STUDENT_API_FAILURE,
  ADD_STUDENT_PROGRAM,
  STUDENT_PROGRAM_API_REQUEST,
  STUDENT_PROGRAM_API_SUCCESS,
  STUDENT_PROGRAM_API_FAILURE,
  ADD_STUDENT_APPLICATIONS,
  STUDENT_APPLICATIONS_API_REQUEST,
  STUDENT_APPLICATIONS_API_SUCCESS,
  STUDENT_APPLICATIONS_API_FAILURE,
  LOGGED_OUT_USER_ADDRESS,
  CLEAR_LOGGED_OUT_USER_ADDRESS,
  ADD_STUDENT_WAITLISTS,
  STUDENT_WAITLISTS_API_REQUEST,
  STUDENT_WAITLISTS_API_SUCCESS,
  STUDENT_WAITLISTS_API_FAILURE,
  ADD_PENDING_WAITLIST_PROGRAMS,
  SAVE_ADDITIONAL_QUESTIONS,
  SAVE_ADDITIONAL_QUESTIONS_SUCCESS,
  SAVE_ADDITIONAL_QUESTIONS_FAILURE,
  ADD_ACCEPTED_OFFERS,
  ADD_DECLINED_OFFERS,
  ADD_PENDING_WAITLIST_OFFERS,
  ADD_OPT_OUT_OFFERS,
  ADD_NO_RESPONSE_OFFERS,
  STUDENT_API_REQUEST_BY_ID,
  STUDENT_API_SUCCESS_BY_ID,
  STUDENT_API_FAILURE_BY_ID,
  GET_SR_ADDITIONAL_QUESTIONS_SUCCESS,
  GET_SR_ADDITIONAL_QUESTIONS_FAILURE,
  UPDATE_WAITLIST_OFFERS,
  UPDATE_WAITLIST_OFFERS_SUCCESS,
} from './actionTypes';
import { GET_ADDED_APPLICATION_PROGRAM } from '../constants';
import fetchErrorHandler from '../services/fetchErrorHandler';
import { getCsrfToken } from '../utils/helpers';
// import { handleOfferDecision } from '../actions/schools';

const studentApiRequest = () => ({
  type: STUDENT_API_REQUEST,
});

const studentApiSuccess = () => ({
  type: STUDENT_API_SUCCESS,
});

const studentApiFailure = error => ({
  type: STUDENT_API_FAILURE,
  error,
});

const studentApiRequestById = () => ({
  type: STUDENT_API_REQUEST_BY_ID,
});

const studentApiSuccessById = studentInfo => ({
  type: STUDENT_API_SUCCESS_BY_ID,
  payload: {
    studentInfo,
  },
});

const studentApiFailureById = error => ({
  type: STUDENT_API_FAILURE_BY_ID,
  error,
});

const addStudent = studentInfo => ({
  type: ADD_STUDENT,
  payload: {
    studentInfo,
  },
});

const studentProgramApiRequest = () => ({
  type: STUDENT_PROGRAM_API_REQUEST,
});

const studentProgramApiSuccess = () => ({
  type: STUDENT_PROGRAM_API_SUCCESS,
});

const studentProgramApiFailure = error => ({
  type: STUDENT_PROGRAM_API_FAILURE,
  error,
});

const addStudentPrograms = studentPrograms => ({
  type: ADD_STUDENT_PROGRAM,
  payload: {
    studentPrograms,
  },
});

const studentApplicationsApiRequest = () => ({
  type: STUDENT_APPLICATIONS_API_REQUEST,
});

const studentApplicationsApiSuccess = () => ({
  type: STUDENT_APPLICATIONS_API_SUCCESS,
});

const studentApplicationsApiFailure = error => ({
  type: STUDENT_APPLICATIONS_API_FAILURE,
  error,
});
const addStudentApplications = studentApplications => ({
  type: ADD_STUDENT_APPLICATIONS,
  payload: {
    studentApplications,
  },
});

const studentWaitlistsApiRequest = () => ({
  type: STUDENT_WAITLISTS_API_REQUEST,
});

const studentWaitlistsApiSuccess = () => ({
  type: STUDENT_WAITLISTS_API_SUCCESS,
});

const studentWaitlistsApiFailure = error => ({
  type: STUDENT_WAITLISTS_API_FAILURE,
  error,
});
const addStudentWaitlists = studentWaitlists => ({
  type: ADD_STUDENT_WAITLISTS,
  payload: {
    studentWaitlists,
  },
});

const getApplicationProgramSavedProgram = studentApplication => ({
  type: GET_ADDED_APPLICATION_PROGRAM,
  payload: studentApplication,
});

const getSrAdditionalQuestions = questions => ({
  type: GET_SR_ADDITIONAL_QUESTIONS_SUCCESS,
  payload: { questions },
});

export const getStudent = applicationId => async (dispatch, getState, { fetch }) => {
  const { apiVersion } = getState().runtime;
  const { locale } = getState().intl;
  dispatch(studentApiRequest());
  return fetch(`${locale}/api/${apiVersion}/application/${applicationId}/student-info/`, {
    credentials: 'include',
    headers: {
      'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
      'X-CSRFToken': getCsrfToken(),
    },
  })
    .then(fetchErrorHandler)
    .then(resp => resp.json())
    .then(studentInfo => {
      dispatch(
        addStudent({
          studentInfo,
        }),
      );
      dispatch(studentApiSuccess());
    })
    .catch(error => {
      console.error('error', error);
      dispatch(studentApiFailure({ error }));
    });
};

export const getStudentPrograms = applicationId => async (dispatch, getState, { fetch }) => {
  const { apiVersion } = getState().runtime;
  const { locale } = getState().intl;

  dispatch(studentProgramApiRequest());
  return fetch(`${locale}/api/${apiVersion}/application/${applicationId}/saved-programs/`, {
    credentials: 'include',
    headers: {
      'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
      'X-CSRFToken': getCsrfToken(),
    },
  })
    .then(fetchErrorHandler)
    .then(resp => resp.json())
    .then(studentPrograms => {
      dispatch(
        addStudentPrograms({
          studentPrograms,
        }),
      );
      dispatch(studentProgramApiSuccess());
    })
    .catch(error => {
      console.error('error', error);
      dispatch(studentProgramApiFailure({ error }));
    });
};

const directoryProgram = new schema.Entity('directoryProgram');
const indApplication = new schema.Entity(
  'application',
  {
    directoryProgram,
  },
  {
    idAttribute(value) {
      return value.directory_program.id;
    },
  },
);

// const combined = new Schema('combined');
/* combined.define({
  basic: indApplication,
  application_program: application_program,
}); */
const normalizedApplications = new schema.Array(indApplication);

export const getStudentApplications = applicationId => async (dispatch, getState, { fetch }) => {
  const { apiVersion } = getState().runtime;
  const { locale } = getState().intl;
  let c_page = '';
  if (window.location.pathname.indexOf('schools') > -1) {
    c_page = 'schools';
  } else if (window.location.pathname.indexOf('apply') > -1) {
    c_page = 'apply';
  }
  dispatch(studentApplicationsApiRequest());
  return fetch(`${locale}/api/${apiVersion}/application/${applicationId}/application-programs/?c_page=${c_page}`, {
    credentials: 'include',
    headers: {
      'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
      'X-CSRFToken': getCsrfToken(),
    },
  })
    .then(fetchErrorHandler)
    .then(resp => resp.json())
    .then(studentApplications => {
      if (c_page == 'apply') {
        const normalStudentApplications = normalize(studentApplications, normalizedApplications);
        dispatch(
          addStudentApplications({
            normalStudentApplications,
          }),
        );
      } else {
        dispatch(getApplicationProgramSavedProgram(studentApplications));
      }
      dispatch(studentApplicationsApiSuccess());
    })
    .catch(error => {
      console.error('error', error);
      dispatch(studentApplicationsApiFailure({ error }));
    });
};

const indWaitlist = new schema.Entity(
  'waitlist',
  {
    directoryProgram,
  },
  {
    idAttribute(value) {
      return value.directory_program.id;
    },
  },
);

const normalizedWaitlists = new schema.Array(indWaitlist);

export const getStudentWaitlists = applicationId => async (dispatch, getState, { fetch }) => {
  const { apiVersion } = getState().runtime;
  const { locale } = getState().intl;
  dispatch(studentWaitlistsApiRequest());
  return fetch(`${locale}/api/${apiVersion}/application/${applicationId}/waitlist-programs/`, {
    credentials: 'include',
    headers: {
      'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
      'X-CSRFToken': getCsrfToken(),
    },
  })
    .then(fetchErrorHandler)
    .then(resp => resp.json())
    .then(allWaitlistData => {
      const studentWaitlists = allWaitlistData.filter(({ offer_status }) => offer_status === 'WL');
      const waitlistsOffers = allWaitlistData.filter(({ offer_status }) => offer_status === 'OF');
      const acceptedWaitlistOffers = waitlistsOffers.filter(({ offer_response }) => offer_response === 'AC');
      const declinedWaitlistOffers = waitlistsOffers.filter(({ offer_response }) => offer_response === 'DE');
      const pendingWatlistOffers = waitlistsOffers.filter(({ offer_response }) => offer_response === 'PE');
      const noResponseWatlistOffers = waitlistsOffers.filter(({ offer_response }) => offer_response === 'NR');
      const optOutWatlistOffers = waitlistsOffers.filter(({ offer_response }) => offer_response === 'OO');
      const normalStudentWaitlists = normalize(studentWaitlists, normalizedWaitlists);
      dispatch(
        addStudentWaitlists({
          normalStudentWaitlists,
        }),
      );
      dispatch({
        type: ADD_ACCEPTED_OFFERS,
        payload: acceptedWaitlistOffers,
      });
      dispatch({
        type: ADD_DECLINED_OFFERS,
        payload: declinedWaitlistOffers,
      });
      dispatch({
        type: ADD_OPT_OUT_OFFERS,
        payload: optOutWatlistOffers,
      });
      dispatch({
        type: ADD_NO_RESPONSE_OFFERS,
        payload: noResponseWatlistOffers,
      });
      dispatch({
        type: ADD_PENDING_WAITLIST_OFFERS,
        payload: pendingWatlistOffers,
      });
      // we're gonna use this for additional questions only:
      dispatch({
        type: ADD_PENDING_WAITLIST_PROGRAMS,
        payload: studentWaitlists,
      });
      dispatch(studentWaitlistsApiSuccess());
    })
    .catch(error => {
      console.error('error', error);
      dispatch(studentWaitlistsApiFailure({ error }));
    });
};

export const getCurrentOffers = applicationId => async (dispatch, getState, { fetch }) => {
  const { apiVersion } = getState().runtime;
  const { locale } = getState().intl;
  dispatch(studentWaitlistsApiRequest());
  return fetch(`${locale}/api/${apiVersion}/application/${applicationId}/waitlist-programs/`, {
    credentials: 'include',
    headers: {
      'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
      'X-CSRFToken': getCsrfToken(),
    },
  })
    .then(fetchErrorHandler)
    .then(resp => resp.json())
    .then(studentWaitlists => {
      const normalStudentWaitlists = normalize(studentWaitlists.results, normalizedWaitlists);
      dispatch(
        addStudentWaitlists({
          normalStudentWaitlists,
        }),
      );
      dispatch(studentWaitlistsApiSuccess());
    })
    .catch(error => {
      console.error('error', error);
      dispatch(studentWaitlistsApiFailure({ error }));
    });
};

export const getWaitlistOffers = applicationId => async (dispatch, getState, { fetch }) => {
  const { apiVersion } = getState().runtime;
  const { locale } = getState().intl;
  dispatch(studentWaitlistsApiRequest());
  return fetch(`${locale}/api/${apiVersion}/application/${applicationId}/waitlist-programs/`, {
    credentials: 'include',
    headers: {
      'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
      'X-CSRFToken': getCsrfToken(),
    },
  })
    .then(fetchErrorHandler)
    .then(resp => resp.json())
    .then(studentWaitlists => {
      const normalStudentWaitlists = normalize(studentWaitlists.results, normalizedWaitlists);
      dispatch(
        addStudentWaitlists({
          normalStudentWaitlists,
        }),
      );
      dispatch(studentWaitlistsApiSuccess());
    })
    .catch(error => {
      console.error('error', error);
      dispatch(studentWaitlistsApiFailure({ error }));
    });
};

export const updateQuestionsAnswers = () => async (dispatch, getState, { fetch }) => {
  // Doing this to update additional questions after submit
  const { apiVersion } = getState().runtime;
  const { applicationId } = getState().user;
  const { locale } = getState().intl;
  dispatch(studentWaitlistsApiRequest());
  return fetch(`${locale}/api/${apiVersion}/application/${applicationId}/waitlist-programs/`, {
    credentials: 'include',
    headers: {
      'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
      'X-CSRFToken': getCsrfToken(),
    },
  })
    .then(fetchErrorHandler)
    .then(resp => resp.json())
    .then(allWaitlistData => {
      const studentWaitlists = allWaitlistData.filter(({ offer_status }) => offer_status === 'WL');
      dispatch({
        type: ADD_PENDING_WAITLIST_PROGRAMS,
        payload: studentWaitlists,
      });
      dispatch(studentWaitlistsApiSuccess());
      window.location.reload();
    })
    .catch(error => {
      console.error('error', error);
      dispatch(studentWaitlistsApiFailure({ error }));
    });
};

export const saveSRAdditionalQuestionsAnswers = (waitlist_id, answers, program_id, is_edit) => async (
  dispatch,
  getState,
  { fetch },
) => {
  const { apiVersion } = getState().runtime;
  const { locale } = getState().intl;
  const { applicationId } = getState().user;
  const url = `${locale}/api/${apiVersion}/application/${applicationId}/additional-questions/?is_sr=true`;
  // eslint-disable-next-line camelcase

  return fetch(url, {
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-CSRFToken': getCsrfToken(),
    },
    method: 'POST',
    body: JSON.stringify(answers),
  })
    .then(fetchErrorHandler)
    .then(resp => resp.json())
    .then(resp => {
      if (resp.status == 'OK') {
        dispatch({
          type: SAVE_ADDITIONAL_QUESTIONS,
        });
        if (!is_edit) {
          //   dispatch(handleOfferDecision(program_id, waitlist_id, true));
          dispatch({
            type: UPDATE_WAITLIST_OFFERS,
            payload: {
              waitlistId: waitlist_id,
              offerResponse: 'AC',
            },
          });
        }
        dispatch({ type: UPDATE_WAITLIST_OFFERS_SUCCESS });
      }
      return resp;
    })
    .catch(error => error);
};

export const saveAdditionalQuestionsAnswers = answers => async (dispatch, getState, { fetch }) => {
  const { apiVersion } = getState().runtime;
  const { locale } = getState().intl;
  const { applicationId } = getState().user;
  const url = `${locale}/api/${apiVersion}/application/${applicationId}/additional-questions/`;
  // eslint-disable-next-line camelcase

  return fetch(url, {
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-CSRFToken': getCsrfToken(),
    },
    method: 'POST',
    body: JSON.stringify(answers),
  })
    .then(fetchErrorHandler)
    .then(resp => resp.json())
    .then(() => {
      dispatch({
        type: SAVE_ADDITIONAL_QUESTIONS,
      });
    })
    .then(() => {
      // Update additional questions after submit:
      updateQuestionsAnswers()(dispatch, getState, { fetch });
      dispatch({ type: SAVE_ADDITIONAL_QUESTIONS_SUCCESS });
    })
    .catch(error => {
      console.error('error', error);
      dispatch({ type: SAVE_ADDITIONAL_QUESTIONS_FAILURE, payload: error });
    });
};

export const getSRAdditionalQuestions = waitlist_id => async (dispatch, getState, { fetch }) => {
  const { apiVersion } = getState().runtime;
  const { locale } = getState().intl;
  const url = `${locale}/api/${apiVersion}/application/${waitlist_id}/additional-questions/?is_sr=true`;
  // eslint-disable-next-line camelcase

  return fetch(url, {
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-CSRFToken': getCsrfToken(),
    },
    method: 'GET',
  })
    .then(fetchErrorHandler)
    .then(resp => resp.json())
    .then(resp => {
      dispatch({ type: GET_SR_ADDITIONAL_QUESTIONS_SUCCESS, payload: resp });
      dispatch(getSrAdditionalQuestions(resp));
    })
    .catch(error => {
      console.error('error', error);
      dispatch({ type: GET_SR_ADDITIONAL_QUESTIONS_FAILURE, payload: error });
    });
};

export const setLoggedOutAddress = (latlng, formattedAddress) => dispatch => {
  dispatch({
    type: LOGGED_OUT_USER_ADDRESS,
    payload: {
      latlng,
      formattedAddress,
    },
  });
};

export const clearLoggedOutAddress = () => dispatch => {
  dispatch({
    type: CLEAR_LOGGED_OUT_USER_ADDRESS,
  });
};

export const getSHSResults = studentId => async (dispatch, getState, { fetch }) => {
  const { apiVersion } = getState().runtime;
  const { locale } = getState().intl;
  const url = `${locale}/api/${apiVersion}/student/${studentId}/shsat-results/`;
  dispatch(studentApiRequestById());
  return fetch(url, {
    credentials: 'include',
    headers: {
      'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
      'X-CSRFToken': getCsrfToken(),
    },
  })
    .then(fetchErrorHandler)
    .then(resp => resp.json())
    .then(studentInfo => {
      dispatch(
        studentApiSuccessById({
          studentInfo,
        }),
      );
    })
    .catch(error => {
      console.error('error', error);
      dispatch(studentApiFailureById({ error }));
    });
};

export { getStudent as default };
